import { ACTIONS } from '../../constants';
import * as Mover from '../../utils/Mover';

// ---------------------------------------------------
// Timeline
// ---------------------------------------------------

export const setSceneVideo = (videoId, position = 1) => dispatch => {
  dispatch({
    type: ACTIONS.SET_SCENE_VIDEO,
    videoId,
    position,
  });
  Mover.setSceneVideo(videoId, position); // note - not ideal (completely remove Mover)
};

export const setHoveredSpot = spotId => ({
  type: ACTIONS.SET_HOVERED_SPOT,
  spotId,
});

export const setHiliteId = hiliteId => ({
  type: ACTIONS.SET_HILITE_ID,
  hiliteId,
});

export const setSubSection = sectionId => dispatch => {
  dispatch({
    type: ACTIONS.SET_SUB_SECTION,
    sectionId,
  });
  Mover.setSceneVideo('', 1); // note - not ideal (completely remove Mover)
};

// ---------------------------------------------------
// Sound
// ---------------------------------------------------

export const soundBlocked = soundBlockState => ({
  type: ACTIONS.SOUND_BLOCKED,
  soundBlockState,
});

// ---------------------------------------------------
// Videos
// ---------------------------------------------------

export const videoComplete = videoId => ({
  type: ACTIONS.VIDEO_COMPLETE,
  videoId,
});

// ---------------------------------------------------
// Compact
// ---------------------------------------------------

export const setCompactVideo = videoId => ({
  type: ACTIONS.SET_COMPACT_VIDEO,
  videoId,
});

// ---------------------------------------------------
// Sub pages
// ---------------------------------------------------

export const setSubPage = pageId => ({
  type: ACTIONS.SET_SUBPAGE,
  pageId,
});

// ---------------------------------------------------
// Resize
// ---------------------------------------------------

export const updateSize = (width, height) => ({
  type: ACTIONS.RESIZE,
  width,
  height,
});

export const setFullscreen = fsState => ({
  type: ACTIONS.SET_FULLSCREEN,
  fsState,
});



// WEBPACK FOOTER //
// ./src/redux/actions/index.js